<template>
    <div class="carContainer">
        <!-- Form -->
        <VeeForm v-slot="{ meta:formMeta, handleSubmit }">           
            <form @submit.prevent="handleSubmit(onSubmit)">
                <div class="my-[40px] md:my-[80px] p-0 md:px-[50px] md:py-[50px] border-0 md:border border-gray-400 rounded-2xl">
                    <div class="max-w-[768px] mx-auto flex flex-col justify-center">
                        <div class="pb-4 flex-auto text-center text-[24px] md:text-[30px] font-medium">
                            會員登入
                        </div>
                        
                        <IdField
                            v-model="account"
                            :plain-text="false"
                            :member-style="true"
                            :autofocus="true"
                            title="帳號"
                            name="帳號"
                            input-id="CustomerId"
                            input-message=""
                            placeholder="既有會員請輸入身分證 / 居留證號進行登入"
                            rules="required|taiwanPersonalId"
                            class="mt-[20px]"
                        />

                        <BirthdayField
                            v-model="birthday"
                            :assured-style="true"
                            :plain-text="false"
                            :member-style="true"
                        />

                        <div class="mt-8 text-center">
                            <p>
                                還不是會員？初次投保請填寫資料加入會員
                            </p>
                            <router-link
                                data-accuid="Register"
                                :to="{ name: 'Register' }"
                                class="underline text-blue"
                            >
                                立即填寫資料
                            </router-link>
                        </div>
                    </div>
                </div>
            </form>
        
            <div class="max-w-3xl mx-auto flex flex-col justify-center">
                <div class="flex align-center gap-[30px] md:gap-[60px] mx-auto">
                    <FormButton
                        data-accuid="Login_Back"
                        text="返回"
                        outline
                        @click="onBack"
                    />
                    <FormButton
                        data-accuid="Login_Confirm"
                        :disabled="!formMeta.valid || !birthday"
                        @click="onSubmit"
                    />
                </div>

                <div class="mt-[30px] leading-6 flex gap-x-2 mx-auto items-start">
                    <div class="mt-0.5 shrink-0">
                        <img
                            src="@/assets/images/icons/bell.svg"
                            loading="lazy"
                            alt="bell"
                            class="w-[20px]"
                        >
                    </div>
                    <div class="flex-1">
                        會員即為要保人。付款人可為要保人（會員）或被保險人（車主）之信用卡或帳戶繳交保費。
                    </div>
                </div>
            </div>
        </VeeForm>
        <!-- / Form -->
    </div>
</template>

<script>
import FormButton from '@/components/forms/Button';
import IdField from '@/components/forms/fields/Id';
import BirthdayField from '@/components/forms/fields/Birthday';

/**
 * 登入頁
 */
export default {
    name: 'LoginView',
    components: {
        FormButton,
        IdField,
        BirthdayField
    },
    data() {
        /**
         * @param {String} account 帳號：身分證字號或居留證號
         * @param {String} birthday 生日
         */
        return {
            account: null,
            birthday: null,
            to: this.$store.state.nav.to || {name: 'Home'},
            from: this.$store.state.nav.from || {name: 'Home'}
        };
    },
    beforeUnmount() {
        // 原本按叉叉或登入完成後 畫面會鎖住 強制移除overflow-hidden使 body 元素的內容允許滾動
        document.body.classList.remove('overflow-hidden');
    },
    mounted() {
        this.pushDataLayerForPageView();
    },
    methods: {
        /**
         * 到上一步
         * 
         * @public
         */        
        onBack() {
            this.$router.push(this.from);
        },
        /**
         * 點擊登入頁面確定按鈕送出表單
         * 
         * @public
         */
        onSubmit() {

            this.$store.commit('showLoading');

            this.account = this.account.toUpperCase();

            this.$store.commit('auth/setAccount', this.account); // account 先存，如果需重填可以補到 input
            this.$store.commit('auth/setBirthday', this.birthday); // account 先存，如果需重填可以補到 input

            axios.post(apiUrl.Login, {
                'account': this.account,
                'birthday': this.birthday,
                'sourceRemark': this.$store.state.insCategory === 'Car' ? '汽車險' : '機車險'
            }).then(res => {
                if (!res.data || res.data.code !== 200) {

                    this.$store.commit('setDialog', {
                        title: '填寫資料錯誤',
                        text: '您填入的資料有誤，請確認後重新輸入。<br>※若一直無法登入，請聯繫客服，確認您的個人資料。',
                        active: true
                    });

                    this.$store.commit('closeLoading');
                    return;
                }

                this.$store.commit('otp/setLogin', {
                    email: res.data.data.otpEmail,
                    id: res.data.data.otpId,
                    mobile: res.data.data.otpMobile,
                    frontCode: res.data.data.otpFrontCode,
                    expired: res.data.data.otpExpireTime,
                    birthday: this.birthday
                });

                this.$store.commit('nav/setAll', {clear: true, to: this.to});
                return this.$router.push({name: 'LoginOtp'});

            }).catch(err => {

                this.$store.commit('setDialog', {
                    title: '填寫資料錯誤',
                    text: err.response ? err.response.data.message : null,
                    active: true
                });
                this.$store.commit('closeLoading');
            });
        },
        /**
         * 推送GA4 DataLayer page_view
         */
        pushDataLayerForPageView(){
            let item = {
                pageUrl: window.location.href,
                pageTitle: document.title
            };
            this.$ga.pushDataLayerForPageView(item);
        }
    }
};
</script>

<style scoped>
.slide-enter-active, .slide-leave-active {
    transition: all .3s ease;
}

.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */
{
    transform: translateY(20px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #005BAC;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}
</style>